module.exports = __webpack_public_path__ + "jpg/roulette-pattern.jpg?3660af99ea4ef5aed0cbd462cff5af53";